import React from 'react';
import SEO from './SEO';

export default function ProductSEO({
  name,
  description,
  slug,
  imagePath,
  price = 1 // fiyat gelmese de sayısal varsayılan
}) {
  const siteUrl = 'https://seymenkimya.com';
  const canonical = slug ? `${siteUrl}/${slug}` : siteUrl;
  const image = imagePath
    ? (imagePath.startsWith('http') ? imagePath : `${siteUrl}/${imagePath}`)
    : `${siteUrl}/assets/images/og-default.webp`;

  const productStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    'name': name,
    'description': description,
    'image': [image],
    'brand': { '@type': 'Brand', 'name': 'Seymen Kimya' },
    'manufacturer': { '@type': 'Organization', 'name': 'Seymen Kimya' },
    'category': 'Temizlik Ürünleri',
    'offers': {
      '@type': 'Offer',
      'priceCurrency': 'TRY',
      'price': price,
      'availability': 'https://schema.org/InStock',
      'url': canonical,
      'itemCondition': 'https://schema.org/NewCondition'
    }
  };

  return (
    <SEO
      title={`${name} | Seymen Kimya`}
      description={description}
      canonical={canonical}
      type="product"
      image={image}
      structuredData={productStructuredData}
    />
  );
}